import React, {useState} from "react";
import './entries.css'

const ManualMeditionModal = ({ master, onClose }) => {
    const [isClosing, setIsClosing] = useState(false);  // para animacion cuando se cierre el modal

    const [formData, setFormData] = useState({
        grossWeight: '',
        grossVolume: '',
        realWeight: '',
        realVolume: '',
    });

    const [errors, setErrors] = useState({
        grossWeight: false,
        grossVolume: false,
        realWeight: false,
        realVolume: false,
    });

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
          onClose();
        }, 300); // mismo tiempo que la animación (0.3s)
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
        setErrors(prev => ({ ...prev, [id]: false })); // Limpiar error al escribir
    };

    const handleAccept = () => {
        const newErrors = {
            grossWeight: !formData.grossWeight,
            grossVolume: !formData.grossVolume,
            realWeight: !formData.realWeight,
            realVolume: !formData.realVolume,
        };

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(Boolean);
        if (!hasErrors) {
            console.log("Todo válido, enviando datos...", formData);
            // lógica para enviar los datos
        } else {
            console.log("Hay errores en el formulario.");
        }
    };

    const handleCancel = () => {
        alert('Cancelar');
    };

    return(
        <div className="modal show d-block" tabIndex="-1"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: 1050
            }}
        >
            {/* Fondo oscuro */}
            <div
                style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1040
                }}
            />
            <div className={`modal-dialog modal-lg ${isClosing ? 'modal-slide-up' : 'modal-slide-down'}`}
                style={{
                    position: 'relative',
                    zIndex: 1060,
                    margin: '5vh auto'
                }}
            >
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#020C41', color: 'white', padding: '0.5rem 1rem' }}>
                        <h5 className="modal-title m-0">Medición Manual</h5>
                        <button type="button" className="btn-close btn-close-white" onClick={handleClose}></button>
                    </div>

                    <div className="modal-body container-fluid">
                        <div className="row mt-2 mb-3">
                            <div className="col-3">
                                <label for="grossWeight" class="amc-label">Gross Weight*</label>
                                <input type="number" class="form-control" id="grossWeight" value={formData.grossWeight} onChange={handleChange} />
                                {errors.grossWeight && <div className="text-danger" style={{ fontSize: '0.8rem' }}>Campo obligatorio</div>}
                            </div>
                            <div className="col-3">
                                <label for="grossVolume" class="amc-label">Gross Volume*</label>
                                <input type="number" class="form-control" id="grossVolume" value={formData.grossVolume} onChange={handleChange} />
                                {errors.grossVolume && <div className="text-danger" style={{ fontSize: '0.8rem' }}>Campo obligatorio</div>}
                            </div>
                            <div className="col-3">
                                <label for="realWeight" class="amc-label">Real Weight*</label>
                                <input type="number" class="form-control" id="realWeight" value={formData.realWeight} onChange={handleChange} />
                                {errors.realWeight && <div className="text-danger" style={{ fontSize: '0.8rem' }}>Campo obligatorio</div>}
                            </div>
                            <div className="col-3">
                                <label for="realVolume" class="amc-label">Real Volume*</label>
                                <input type="number" class="form-control" id="realVolume" value={formData.realVolume} onChange={handleChange} />
                                {errors.realVolume && <div className="text-danger" style={{ fontSize: '0.8rem' }}>Campo obligatorio</div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col mt-2 d-flex justify-content-end gap-2">
                                <button className='btnn' onClick={handleClose} >Cancelar</button>
                                <button className='btnn' onClick={handleAccept} >Aceptar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManualMeditionModal;